import { ParameterType } from '@/study-search/enums';
import { TitleBase } from './TitleBase';

export default class TitleContinent extends TitleBase {
	private continentValue: string;

	protected canHandle(): boolean {
		this.continentValue = this.getFilterValue(ParameterType.CONTINENT);

		return this.indexableFilters.some((_) => _.type === ParameterType.CONTINENT);
	}

	protected getPageTitle(): string {
		return `${this.titlePortalType} in ${this.continentValue}`;
	}

	protected getMetaDescription(): string {
		return this.buildMetaDescription(this.titlePortalType, ` in ${this.continentValue}`);
	}
}
